import { Component, OnInit, Input } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-pay-one',
  templateUrl: './pay-one.component.html',
  styleUrls: ['./pay-one.component.scss'],
})
export class PayOneComponent implements OnInit {
  @Input() payOneUrl: string = '';

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef
  ) {}

  ngOnInit(): void {
    this.payOneUrl = this.config.data.payOneUrl;
  }
}
